<template>
    <div class="page_header">
        <a-button type="primary" class="offline_btn" @click="offline" v-if="open==true && (info.admin==true || (staffs.pd && staffs.pd.id==user.id) || (staffs.qa&&staffs.qa.id==user.id))"><a-icon type="eye-invisible" />{{$t("pageHeader.offline")}}</a-button>
        <div class="rememberConfig">
            <a-checkbox v-model="remember">{{$t("pageHeader.saveSetting")}}</a-checkbox>
        </div>
        <a-breadcrumb class="page_breadcrumb">
            <a-breadcrumb-item >
                <a-icon :style="{ color: '#1890ff', paddingRight: '4px' }" :component="GamepadSvg" />
                <router-link :to="{name:'menu'}"><span class="bc-click-item">{{$t("pageHeader.gameSpec")}}</span></router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>
                <router-link :to="{name:'menu', query: {tab: `${config.parent}`}}"><span class="bc-click-item">{{config.parent}}</span></router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>{{config.name}}</a-breadcrumb-item>
        </a-breadcrumb>
        <h2 :title="config.name">{{config.name}}
            <span class="page_star" :class="{'star':star}" @click="changeStar(!star)">
                <a-icon type="star" theme="filled" />
            </span>
            <a :href="`manage.html?proj=${$service.PROJ_CODE}#/page?id=${$route.query.id}`" target="_blank" class="page_setting" v-if="(info.admin==true || (staffs.us && staffs.us.id==user.id) || (staffs.pd && staffs.pd.id==user.id) || (staffs.qa && staffs.qa.id==user.id))">{{$t("pageHeader.pageConfig")}}</a>
            <p class="page_staff" v-if="staffs">
                <span v-if="staffs.pd">{{$t("pageHeader.demandFollow")}}：&nbsp;{{staffs.pd.name}} <a @click="loadPopo(staffs.pd.email)" class="popo" v-if="staffs.pd.email"></a></span>
                <span v-if="staffs.us">{{$t("pageHeader.dataDevelop")}}：&nbsp;{{staffs.us.name}}</span>
                <span v-if="staffs.qa">{{$t("pageHeader.qa")}}：&nbsp;{{staffs.qa.name}}</span>
            </p>
        </h2>
        <div class="page_desc" v-html="config.desc"></div>
    </div>
</template>

<script>
import {Breadcrumb, Modal, Checkbox} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Breadcrumb)
Vue.use(Modal)
Vue.use(Checkbox)
import {encrypt} from '@/utils/utils'
import GamepadSvg from '@/components/icons/GamepadSvg';

export default {
    computed: {
        info() {
            return this.$store.state.game.info
        },
        user() {
            return this.$store.state.user
        },
        config() {
            return this.$store.state.config.page
        },
        staffs() {
            let staffs = this.$store.state.config.page.staffs
            return staffs?staffs:{}
        },
        status() {
            return this.$store.state.config.page.status
        },
        open() {
            return this.$store.state.config.page.open
        },
        star() {
            return this.$store.state.config.page.star
        },
        remember: {
            get() {
                return this.$store.state.config.remember
            },
            set(value) {
                if(typeof(value)=='boolean') {
                    this.$store.dispatch('set_remember', value)
                }
            },
        },
    },
    data() {
        return {
            local_remember: null,
            GamepadSvg,
        }
    },
    methods: {
        offline() {
            let self = this
            Modal.confirm({
                zIndex: 1030,
                title: '下线页面',
                content: '你确认要下线此数据专项页吗？',
                onOk() {
                    self.$service.patchData(`${self.$service.api.manage.submodule}${self.$route.query.id}/status/`, {status:0}).then(data => {
                        self.$message.success("下线成功")
                        self.$store.commit('set_page_config', {id:'status', val:0})
                        self.$store.commit('set_page_config', {id:'open', val:false})
                    })
                },
                onCancel() {},
            });
        },
        loadPopo(email) {
            const b = {
                opss: {
                sstp: 0,
                ssid: email
                }
            }
            window.location.href = 'netease-popoapp://' + encrypt(JSON.stringify(b))
        },
        changeStar(status) {
            this.$service.addData(`${this.$service.api.project.custom_submenu}`, {'submodule':this.$route.query.id, 'status': status}).then((data)=>{
                if(data==true || data) {
                    this.$store.commit('set_page_config', {id:'star', val:status})
                    const _menus = [...this.$store.state.game.menus]
                    const _id = this.$route.query.id
                    let finded = false
                    for(let i=0; i<_menus.length; i++) {
                        const _mod = _menus[i]
                        for(let j=0; j<_mod.sub.length; j++) {
                            if(_mod.sub[j].id===_id) {
                                const _sub = [..._mod.sub]
                                _sub.splice(j, 1, {..._mod.sub[j], star:status?data:status})
                                _menus.splice(i, 1, {..._menus[i], sub:_sub})
                                this.$store.commit('set_menus', _menus)
                                finded = true
                                break
                            }
                        }
                        if(finded) {
                            break
                        }
                    }
                }
            })
            return false
        }
    }
}
</script>


<style lang="less" scoped>
.page_header {
    position: relative;
    background: #fff;
    border-bottom:1px solid #ddd;
    .page_breadcrumb {
        padding: 20px 30px 0 30px;
    }
    .bc-click-item {
        text-underline-offset: 5px;
        color: #1890ff;
        &:hover {
            text-decoration: underline;
            opacity: .85;
        }
    }
    h2 {
        padding: 0 30px;
        margin:16px 0 10px 0;
        font-weight: bold;
    }
    .page_desc {
        padding: 10px 30px 15px 30px;
        font-size: 14px;
        color: #bbb;
    }
    .page_setting {
        margin: 0 0 0 20px;
        padding:0 0 0 25px;
        font-size:13px;
        font-weight: normal;
        height:20px;
        background:url('../../assets/img/setting.png') no-repeat;
        background-size:20px 20px;
    }

    .page_staff {
        font-size: 12px;
        font-weight: normal;
        color: rgba(0,0,0, 0.38);
        float: right;
        margin: 10px 0 0 0;
        span {
            margin: 0 0 0 25px;
            line-height: 20px;
            vertical-align: middle;
            a.popo {
                width:16px; 
                height:16px;
                background:url(../../assets/img/popo.png) no-repeat;
                background-size: 16px 16px;
                display: inline-block;
                vertical-align: middle;
                margin: -2px 0 0 0;
            }
        }
    }

    .page_star {
        cursor: pointer;
        color: #aaa;
        &.star {
            color: #ffb031;
        }
    }
    
    .offline_btn {
        position: absolute;
        top:20px;
        right: 185px;
        background:#F04864; 
        border-color:#F04864; 
        margin:0 10px 0 0;
        float: right;
    }
}
</style>
<style lang="less">
    .rememberConfig {
        position: absolute;
        top:20px;
        right:30px;
        background:#1890ff; 
        padding:5px 10px;
        border-radius: 3px;
        color:#fff; 
        .ant-checkbox-wrapper + span, .ant-checkbox + span {
            color:#fff;
            padding-right: 0;
        }
    }
</style>